function ediparts(state) {
	return state.ediparts;
}

export default { ediparts };